// extracted by mini-css-extract-plugin
export default {"container":"UUUemoPD6TNju0uEJit7","plansAlwaysOn":"g2WWFeRDHJEMPrTEBMEm","priceAndPriceMatch":"VEA4rarEf23Ca3sPfME9","reviewsAndPriceMatch":"pF6w0OzwfPH3r4l4FCC_"};